// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__UYjgl","cardHeader":"styles_cardHeader__TsBMg","totaluser":"styles_totaluser__SK7qx","buttons":"styles_buttons__3wNYu"};